import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "admin-clinic-list py-56" }
const _hoisted_2 = { class: "d-flex mb-56 justify-content-between" }
const _hoisted_3 = { class: "h4 text-primary mb-0" }
const _hoisted_4 = { class: "fw-normal" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-add-ring me-8",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_6 = { class: "d-flex mb-48" }
const _hoisted_7 = { class: "d-flex table-responsive" }
const _hoisted_8 = { class: "fit" }
const _hoisted_9 = {
  class: "fit text-center",
  colspan: "2"
}
const _hoisted_10 = { key: 0 }
const _hoisted_11 = {
  colspan: "222222",
  class: "empty-state py-8 px-12 text-center"
}
const _hoisted_12 = { class: "h-100 w-100 d-flex flex-column align-items-center justify-content-center text-center" }
const _hoisted_13 = { class: "h5 title text-primary mb-48" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-add-ring me-8",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_15 = { class: "fit text-center" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-view-light",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_17 = { class: "fw-normal" }
const _hoisted_18 = { class: "fit text-center" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-edit-light",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_20 = { class: "fw-normal" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_input = _resolveComponent("v-input")!
  const _component_v_button = _resolveComponent("v-button")!
  const _component_v_table_header = _resolveComponent("v-table-header")!
  const _component_v_table_body = _resolveComponent("v-table-body")!
  const _component_v_table = _resolveComponent("v-table")!
  const _component_v_pagination = _resolveComponent("v-pagination")!
  const _component_the_admin_clinic_show = _resolveComponent("the-admin-clinic-show")!
  const _component_the_admin_clinic_edit = _resolveComponent("the-admin-clinic-edit")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h2", _hoisted_3, [
          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t('Listado de')), 1),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('clínicas')), 1)
        ]),
        (_ctx.can('admin.clinic.store'))
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              to: {name: 'admin.clinic.store'},
              class: "btn btn-secondary btn-icon btn-sm",
              "aria-label": _ctx.$t('Nueva clínica')
            }, {
              default: _withCtx(() => [
                _hoisted_5,
                _createTextVNode(" " + _toDisplayString(_ctx.$t('Nueva clínica')), 1)
              ]),
              _: 1
            }, 8, ["to", "aria-label"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_v_input, {
          id: "search",
          class: "me-8",
          placeholder: _ctx.$t('Buscar clínica'),
          value: _ctx.filters.search,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => {_ctx.filters.search = $event; _ctx.search()})
        }, null, 8, ["placeholder", "value"]),
        _createVNode(_component_v_button, {
          variant: "secondary",
          class: "btn-icon text-nowrap",
          "aria-label": _ctx.$t('Limpiar filtros'),
          onClick: _ctx.emptyFilters
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('Limpiar filtros')), 1)
          ]),
          _: 1
        }, 8, ["aria-label", "onClick"])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_v_table, { class: "table-bordered" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_table_header, null, {
              default: _withCtx(() => [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", _hoisted_8, _toDisplayString(_ctx.$t('ID')), 1),
                  _createElementVNode("th", null, _toDisplayString(_ctx.$t('Nombre')), 1),
                  _createElementVNode("th", null, _toDisplayString(_ctx.$t('Dirección')), 1),
                  _createElementVNode("th", null, _toDisplayString(_ctx.$t('Teléfono')), 1),
                  _createElementVNode("th", _hoisted_9, _toDisplayString(_ctx.$t('Acciones')), 1)
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_v_table_body, null, {
              default: _withCtx(() => [
                (!_ctx.clinics.length)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_10, [
                      _createElementVNode("td", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, [
                          _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t('No hay clínicas')), 1),
                          (_ctx.can('admin.clinic.store'))
                            ? (_openBlock(), _createBlock(_component_router_link, {
                                key: 0,
                                to: {name: 'admin.clinic.store'},
                                class: "btn btn-secondary btn-icon btn-sm",
                                "aria-label": _ctx.$t('Nueva clínica')
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_14,
                                  _createTextVNode(" " + _toDisplayString(_ctx.$t('Nueva clínica')), 1)
                                ]),
                                _: 1
                              }, 8, ["to", "aria-label"]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.clinics, (clinic) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: clinic.id
                  }, [
                    _createElementVNode("td", null, _toDisplayString(clinic.id), 1),
                    _createElementVNode("td", null, _toDisplayString(clinic.name), 1),
                    _createElementVNode("td", null, _toDisplayString(clinic.address), 1),
                    _createElementVNode("td", null, _toDisplayString(clinic.phoneNumber), 1),
                    _createElementVNode("td", _hoisted_15, [
                      (_ctx.can('admin.clinic.show'))
                        ? (_openBlock(), _createBlock(_component_v_button, {
                            key: 0,
                            variant: "icon",
                            class: "btn-sm justify-content-center d-flex flex-column p-0",
                            onClick: () => { _ctx.openClinicShowModal(clinic) }
                          }, {
                            default: _withCtx(() => [
                              _hoisted_16,
                              _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.$t('Ver')), 1)
                            ]),
                            _: 2
                          }, 1032, ["onClick"]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("td", _hoisted_18, [
                      (_ctx.can('admin.clinic.update'))
                        ? (_openBlock(), _createBlock(_component_v_button, {
                            key: 0,
                            variant: "icon",
                            class: "btn-sm justify-content-center d-flex flex-column p-0",
                            onClick: () => { _ctx.openClinicEditModal(clinic) }
                          }, {
                            default: _withCtx(() => [
                              _hoisted_19,
                              _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.$t('Editar')), 1)
                            ]),
                            _: 2
                          }, 1032, ["onClick"]))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                }), 128))
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      (_ctx.clinics.length > 0)
        ? (_openBlock(), _createBlock(_component_v_pagination, {
            key: 0,
            meta: _ctx.clinicsPagination?.meta,
            pagination: _ctx.clinicsPagination?.pagination,
            onPageChanged: _ctx.handlePageChangedEvent
          }, null, 8, ["meta", "pagination", "onPageChanged"]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.modalToShow === 'the-admin-clinic-show')
      ? (_openBlock(), _createBlock(_component_the_admin_clinic_show, {
          key: 0,
          "clinic-id": _ctx.selectedClinic.id,
          onClosed: _cache[1] || (_cache[1] = ($event: any) => {this.modalToShow = ''; this.selectedClinic = null;})
        }, null, 8, ["clinic-id"]))
      : _createCommentVNode("", true),
    (_ctx.modalToShow === 'the-admin-clinic-edit')
      ? (_openBlock(), _createBlock(_component_the_admin_clinic_edit, {
          key: 1,
          "clinic-id": _ctx.selectedClinic.id,
          onClosed: _cache[2] || (_cache[2] = ($event: any) => {this.modalToShow = ''; this.selectedClinic = null;}),
          onClinicUpdated: _cache[3] || (_cache[3] = ($event: any) => {this.modalToShow = ''; this.selectedClinic = null; this.loadClinics();})
        }, null, 8, ["clinic-id"]))
      : _createCommentVNode("", true)
  ], 64))
}